import { render } from "./ShiftTicketsHistory.vue?vue&type=template&id=265e83f6&scoped=true&ts=true"
import script from "./ShiftTicketsHistory.ts?vue&type=script&lang=ts"
export * from "./ShiftTicketsHistory.ts?vue&type=script&lang=ts"

import "./ShiftTicketsHistory.vue?vue&type=style&index=0&id=265e83f6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265e83f6"]])

export default __exports__